"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Trybe
 * This site provides documentation on how to use the Trybe Shop API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var CustomersApi = /** @class */ (function (_super) {
    __extends(CustomersApi, _super);
    function CustomersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Use this endpoint to lock a `Customer`.  When a customer is locked, their details cannot be modified until their profile is unlocked.  Any requests to [`updateCustomer`](/endpoints/Customers/#updateCustomer) or [`anonymiseCustomer`](/endpoints/Customers/#anonymiseCustomer) will fail with a `400` response.
     * Lock a Customer
     */
    CustomersApi.prototype.actionLockCustomerRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling actionLockCustomer.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/customers/customers/{customerId}/lock".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowCustomerFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to lock a `Customer`.  When a customer is locked, their details cannot be modified until their profile is unlocked.  Any requests to [`updateCustomer`](/endpoints/Customers/#updateCustomer) or [`anonymiseCustomer`](/endpoints/Customers/#anonymiseCustomer) will fail with a `400` response.
     * Lock a Customer
     */
    CustomersApi.prototype.actionLockCustomer = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionLockCustomerRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to resend the email verification email for a `Customer`.  The customer will receive a URL via email which they can use to verify their email address.
     * Resend verification
     */
    CustomersApi.prototype.actionResendCustomerVerificationRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling actionResendCustomerVerification.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/customers/customers/{customerId}/resend-verification".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowCustomerFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to resend the email verification email for a `Customer`.  The customer will receive a URL via email which they can use to verify their email address.
     * Resend verification
     */
    CustomersApi.prototype.actionResendCustomerVerification = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionResendCustomerVerificationRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to trigger a password reset for a `Customer`.  The customer will receive a URL via email which they can use to reset their password.  The URL will be valid for 1 hour.
     * Trigger reset password
     */
    CustomersApi.prototype.actionTriggerCustomerPasswordResetRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling actionTriggerCustomerPasswordReset.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/customers/customers/{customerId}/reset-password".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowCustomerFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to trigger a password reset for a `Customer`.  The customer will receive a URL via email which they can use to reset their password.  The URL will be valid for 1 hour.
     * Trigger reset password
     */
    CustomersApi.prototype.actionTriggerCustomerPasswordReset = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionTriggerCustomerPasswordResetRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to unlock a `Customer`.
     * Unlock a Customer
     */
    CustomersApi.prototype.actionUnlockCustomerRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling actionUnlockCustomer.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/customers/customers/{customerId}/unlock".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowCustomerFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to unlock a `Customer`.
     * Unlock a Customer
     */
    CustomersApi.prototype.actionUnlockCustomer = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.actionUnlockCustomerRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to create a new `Customer`.  When creating a new `Customer`, you must specify at least one of the following fields along with any other fields marked as required:  - `email` - `first_name` - `last_name`
     * Create a Customer
     */
    CustomersApi.prototype.createCustomerRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/customers/customers",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.CreateCustomerToJSON(requestParameters.createCustomer),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowCustomerFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to create a new `Customer`.  When creating a new `Customer`, you must specify at least one of the following fields along with any other fields marked as required:  - `email` - `first_name` - `last_name`
     * Create a Customer
     */
    CustomersApi.prototype.createCustomer = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createCustomerRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a `Customer` by their ID.
     * Show a Customer
     */
    CustomersApi.prototype.getCustomerRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getCustomer.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/customers/customers/{customerId}".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowCustomerFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a `Customer` by their ID.
     * Show a Customer
     */
    CustomersApi.prototype.getCustomer = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a list of `Membership`s for the given `Customer`.  When retrieving memberships with this endpoint, the `next_charge` property will be populated if applicable.
     * List a customer\'s memberships
     */
    CustomersApi.prototype.getCustomerMembershipsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getCustomerMemberships.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/customers/customers/{customerId}/memberships".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListCustomerMembershipsFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve a list of `Membership`s for the given `Customer`.  When retrieving memberships with this endpoint, the `next_charge` property will be populated if applicable.
     * List a customer\'s memberships
     */
    CustomersApi.prototype.getCustomerMemberships = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerMembershipsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve high-level stats for a single customer.
     * Get stats for a single customer across the whole organisation
     */
    CustomersApi.prototype.getCustomerStatsRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling getCustomerStats.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/shop/customers/{customerId}/stats".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowDiscountTypeFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to retrieve high-level stats for a single customer.
     * Get stats for a single customer across the whole organisation
     */
    CustomersApi.prototype.getCustomerStats = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCustomerStatsRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This endpoint lists the `Customer`s which are associated to the provided site.
     * List Customers
     */
    CustomersApi.prototype.listCustomersRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.query !== undefined) {
                            queryParameters['query'] = requestParameters.query;
                        }
                        if (requestParameters.email !== undefined) {
                            queryParameters['email'] = requestParameters.email;
                        }
                        if (requestParameters.organisationId !== undefined) {
                            queryParameters['organisation_id'] = requestParameters.organisationId;
                        }
                        if (requestParameters.brandId !== undefined) {
                            queryParameters['brand_id'] = requestParameters.brandId;
                        }
                        if (requestParameters.siteId !== undefined) {
                            queryParameters['site_id'] = requestParameters.siteId;
                        }
                        if (requestParameters.membershipNumber !== undefined) {
                            queryParameters['membership_number'] = requestParameters.membershipNumber;
                        }
                        if (requestParameters.name !== undefined) {
                            queryParameters['name'] = requestParameters.name;
                        }
                        if (requestParameters.phone !== undefined) {
                            queryParameters['phone'] = requestParameters.phone;
                        }
                        if (requestParameters.membership !== undefined) {
                            queryParameters['membership'] = requestParameters.membership;
                        }
                        if (requestParameters.membershipCreatedAtFrom !== undefined) {
                            queryParameters['membership_created_at_from'] = requestParameters.membershipCreatedAtFrom;
                        }
                        if (requestParameters.membershipCreatedAtTo !== undefined) {
                            queryParameters['membership_created_at_to'] = requestParameters.membershipCreatedAtTo;
                        }
                        if (requestParameters.membershipTypeId !== undefined) {
                            queryParameters['membership_type_id'] = requestParameters.membershipTypeId;
                        }
                        if (requestParameters.membershipRateId !== undefined) {
                            queryParameters['membership_rate_id'] = requestParameters.membershipRateId;
                        }
                        if (requestParameters.marketingOptIn !== undefined) {
                            queryParameters['marketing_opt_in'] = requestParameters.marketingOptIn;
                        }
                        if (requestParameters.labelIds) {
                            queryParameters['label_ids'] = requestParameters.labelIds.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.id) {
                            queryParameters['id'] = requestParameters.id.join(runtime.COLLECTION_FORMATS["csv"]);
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.perPage !== undefined) {
                            queryParameters['per_page'] = requestParameters.perPage;
                        }
                        headerParameters = {};
                        return [4 /*yield*/, this.request({
                                path: "/customers/customers",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ListCustomersFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * This endpoint lists the `Customer`s which are associated to the provided site.
     * List Customers
     */
    CustomersApi.prototype.listCustomers = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listCustomersRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Use this endpoint to update an existing `Customer`.
     * Update a Customer
     */
    CustomersApi.prototype.updateCustomerRaw = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.customerId === null || requestParameters.customerId === undefined) {
                            throw new runtime.RequiredError('customerId', 'Required parameter requestParameters.customerId was null or undefined when calling updateCustomer.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        return [4 /*yield*/, this.request({
                                path: "/customers/customers/{customerId}".replace("{" + "customerId" + "}", encodeURIComponent(String(requestParameters.customerId))),
                                method: 'PUT',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.UpdateCustomerToJSON(requestParameters.updateCustomer),
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.ShowCustomerFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Use this endpoint to update an existing `Customer`.
     * Update a Customer
     */
    CustomersApi.prototype.updateCustomer = function (requestParameters) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateCustomerRaw(requestParameters)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return CustomersApi;
}(runtime.BaseAPI));
exports.CustomersApi = CustomersApi;
